import { Handout } from "components/handout/Handout";
import {
  doc,
  setDoc,
  getFirestore,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";
import { useQuarterId } from "hooks/UseQuarterId";
import { useUserId } from "hooks/UseUserId";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { useState } from "react";
import { FaPlus, FaTimes } from "react-icons/fa";
import Swal from "sweetalert2";
import { SongLink } from "./components/SongLink";
import { Quote, SongRow, SongTitle } from "./components/SongStyles";
import styled from "styled-components";

const maxSuggestions = 3

export const SongSuggestion = () => {
  return <Handout element={<SongSuggestionInner />} />;
};

const SongSuggestionInner = () => {

  const db = getFirestore();
  const qtrId = useQuarterId();
  const userId = useUserId();
  const suggestionsPath = `/music/${qtrId}/suggestions/${userId}`;

  const [suggestions, suggestionsLoading] = useDocumentData(
    doc(db, suggestionsPath)
  );

  const [newSong, setNewSong] = useState({
    artist: "",
    title: "",
    link: "",
    reason: "",
  });


  const handleAddSuggestion = async () => {
    if (!newSong.artist || !newSong.title || !newSong.link || !newSong.reason) {
      Swal.fire("All fields are required.");
      return;
    }

    try {
      await setDoc(doc(db, suggestionsPath), {
        songs: arrayUnion(newSong),
      }, { merge: true });
      setNewSong({ artist: "", title: "", link: "", reason: "" });
    } catch (error) {
      console.error("Error adding suggestion: ", error);
    }
  };

  const handleInputChange = (field, value) => {
    setNewSong((prev) => ({ ...prev, [field]: value }));
  };

  if (suggestionsLoading) {
    return <p>Loading...</p>;
  }

  const songs = suggestions?.songs || [];

  return (
    <div>
      <h1>Collecting Suggestions of Fresh Songs 🌱</h1>
      <hr />
      <p>You can suggest up to {maxSuggestions} songs for the CS109 Fall25 playlist!</p>

      <h3>Suggest a New Song</h3>
      {songs.length < maxSuggestions ? (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleAddSuggestion();
          }}
        >
          <div className="mt-2">
            <label>
              <strong>Song Link:</strong>
            </label>
            <input
              type="text"
              className="form-control mb-2"
              value={newSong.link}
              onChange={(e) => handleInputChange("link", e.target.value)}
              placeholder="Link to the song (Spotify, YouTube or SoundCloud)"
            />
            <SongLink songLink={newSong.link} artist={newSong.artist} title={newSong.title} />
          </div>
          <div className="mt-2">
            <label>
              <strong>Artist:</strong>
            </label>
            <input
              className="form-control"
              type="text"
              value={newSong.artist}
              onChange={(e) => handleInputChange("artist", e.target.value)}
              placeholder="Artist name"
            />
          </div>
          <div className="mt-2">
            <label>
              <strong>Title:</strong>
            </label>
            <input
              type="text"
              className="form-control"
              value={newSong.title}
              onChange={(e) => handleInputChange("title", e.target.value)}
              placeholder="Song title"
            />
          </div>

          <div className="mt-2">
            <label>
              <strong>Tell us about this song!</strong>
            </label>
            <textarea
              value={newSong.reason}
              className="form-control"
              onChange={(e) => handleInputChange("reason", e.target.value)}
              placeholder="What is interesting about it? What do you like about it?"
            />
          </div>
          <button className="btn btn-primary mt-2" type="submit">
            <FaPlus /> Add Song Suggestion
          </button>
          {/* <button
            type="button"
            onClick={() =>
              setNewSong({ artist: "", title: "", songLink: "", reason: "" })
            }
          >
            <FaTimes /> Clear
          </button> */}
        </form>
      ) : (
        <p>You have reached the maximum of {maxSuggestions} suggestions. Thank you so much for your suggestions!</p>
      )}

      <hr />

      <h3>Your Suggestions</h3>
      <div>
        {songs
          .slice() // Create a shallow copy of the array
          .reverse() // Reverse the order of the copied array
          .map((song, index) => {
            console.log(song);
            return (
              <SongRow key={index}>
                <SongTitle>
                  {song.title} - {song.artist}
                </SongTitle>
                <SongLink
                  songLink={song.link}
                  artist={song.artist}
                  title={song.title}
                />
                <Quote>{song.reason}</Quote>
              </SongRow>
            );
          })}
      </div>
    </div>
  );
};

